import React, { createContext, useState } from "react";

export const SchemaAddClassStateContext = createContext(undefined);
export const SchemaAddClassStateDispatchContext = createContext(undefined);

export const SchemaAddClassStateProvider = ({ children }) => {
  const [state, setState] = useState({
    class: "",
    description: "",
    vectorizeClassName: false,
    properties: [],
  });

  return (
    <SchemaAddClassStateContext.Provider value={state}>
      <SchemaAddClassStateDispatchContext.Provider value={setState}>
        {children}
      </SchemaAddClassStateDispatchContext.Provider>
    </SchemaAddClassStateContext.Provider>
  );
};
